import { map } from 'ramda';
import { t } from '../../../../modules/infra/i18n';
import {
  CATEGORY_FILTER_DESELECT_ALL,
  CATEGORY_FILTER_SELECT_ALL,
  RESET_FILTERS,
  UPDATE_CATEGORY_FILTER,
} from '../constants';
import { CLEAR_ITEMS, FETCH_ITEMS } from '../../services/categories/constants';

const transformToFilter = map(item => ({
  id: item.id,
  title: item.name,
  checked: true,
  type: 'serviceCategory',
}));

const serviceCategoryFilter = (state = [], action) => {
  switch (action.type) {
    case CLEAR_ITEMS:
      return [];
    case FETCH_ITEMS:
      return [
        {
          id: 'uncategorised',
          title: t('reports:service_category_filter.uncategorised'),
          checked: true,
          type: 'serviceCategory',
        },
        ...transformToFilter(action.payload),
      ];
    case UPDATE_CATEGORY_FILTER:
      return state.map((filter) => {
        if (filter === action.payload) {
          filter.checked = !filter.checked;
        }
        return filter;
      });
    case CATEGORY_FILTER_SELECT_ALL:
    case RESET_FILTERS:
      return state.map((filter) => {
        filter.checked = true;
        return filter;
      });
    case CATEGORY_FILTER_DESELECT_ALL:
      return state.map((filter) => {
        filter.checked = false;
        return filter;
      });
    default:
  }
  return state;
};

export default serviceCategoryFilter;
